import { render, staticRenderFns } from "./WorkoutCreateSubmitSlide.vue?vue&type=template&id=dc8ed93e&scoped=true&xmlns=true"
import script from "./WorkoutCreateSubmitSlide.vue?vue&type=script&lang=js"
export * from "./WorkoutCreateSubmitSlide.vue?vue&type=script&lang=js"
import style0 from "./WorkoutCreateSubmitSlide.vue?vue&type=style&index=0&id=dc8ed93e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc8ed93e",
  null
  
)

export default component.exports